/**
 * Cheque Bounce Payments Table Component
 * Displays cheque bounce payment details
 */
import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import NewFeeReciept from '../../finance/newFeeReciept';
import LoadingComponent from '../../loadingComponent';

export class ChequeBouncePaymentsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chequeBouncePayments: [],
            flattenedData: [],
            isLoading: false,
            isEnableReceipt: false,
            receiptData: null
        };

        // Create refs for scroll synchronization
        this.dataScrollRef = React.createRef();

        // Bind methods
        this.processTransactionsData = this.processTransactionsData.bind(this);
    }

    componentDidMount() {
        console.log('ChequeBouncePaymentsTable component mounted');
        const { transactionsData, transactionsLoading } = this.props;

        if (transactionsData) {
            this.processTransactionsData(transactionsData);
        } else if (transactionsLoading === false) {
            this.setState({ isLoading: false, chequeBouncePayments: [], flattenedData: [] });
        }
    }

    componentDidUpdate(prevProps) {
        const { transactionsData, transactionsLoading } = this.props;

        if (transactionsData !== prevProps.transactionsData && transactionsData) {
            this.processTransactionsData(transactionsData);
        } else if (transactionsLoading === false && prevProps.transactionsLoading === true && !transactionsData) {
            this.setState({ isLoading: false, chequeBouncePayments: [], flattenedData: [] });
        }
    }

    processTransactionsData(data) {
        console.log('ChequeBouncePaymentsTable - Processing transactions data:', data);

        const collections = data?.collections || [];

        if (collections && collections.length > 0) {
            // Filter for transactions that have "Cheque Bounce Fine" in feePaidDetails
            const chequeBounceTransactions = collections.filter(transaction => {
                const feePaidDetails = transaction.feePaidDetails || [];
                
                // Check if any feePaidDetail has feeType "Cheque Bounce Fine"
                return feePaidDetails.some(detail => 
                    detail.feeType && detail.feeType === 'Cheque Bounce Fine'
                );
            });

            console.log('Filtered cheque bounce fine transactions:', chequeBounceTransactions.length);

            const flattened = this.flattenTransactions(chequeBounceTransactions);
            console.log('ChequeBouncePaymentsTable - Flattened Data:', flattened);

            this.setState({
                chequeBouncePayments: chequeBounceTransactions,
                flattenedData: flattened,
                isLoading: false
            });
        } else {
            console.log('ChequeBouncePaymentsTable - No collections in data');
            this.setState({
                chequeBouncePayments: [],
                flattenedData: [],
                isLoading: false
            });
        }
    }

    flattenTransactions = (transactions) => {
        const flattened = [];

        transactions.forEach((transaction, transIndex) => {
            const feePaidDetails = transaction.feePaidDetails || [];
            
            // Filter only "Cheque Bounce Fine" fee type details
            const chequeBounceDetails = feePaidDetails.filter(detail => 
                detail.feeType === 'Cheque Bounce Fine'
            );
            
            const totalRows = chequeBounceDetails.length;

            if (totalRows === 0) {
                // If no cheque bounce fine details, skip this transaction
                return;
            } else {
                chequeBounceDetails.forEach((detail, detailIndex) => {
                    flattened.push({
                        sNo: transIndex + 1,
                        transaction: transaction,
                        detail: detail,
                        transIndex: transIndex,
                        detailIndex: detailIndex,
                        isFirstRow: detailIndex === 0,
                        isLastRow: detailIndex === totalRows - 1,
                        totalRowSpan: totalRows,
                        uniqueKey: `${transaction._id}-${detailIndex}`
                    });
                });
            }
        });

        return flattened;
    };

    formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    // Column body templates
    snoBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return (
            <span style={{ display: 'block', textAlign: 'center' }}>
                {rowData.sNo}
            </span>
        );
    };

    chequeNumberBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.transaction.receiptNo || 'N/A'}</span>;
    };

    chequeBounceBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{this.formatDate(rowData.transaction.receiptDate || rowData.transaction.transactionDate)}</span>;
    };

    feeAccountNameBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.transaction.destinationBankName || 'N/A'}</span>;
    };

    bounceRemarksBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return <span>{rowData.transaction.remarks || rowData.transaction.paymentMode || 'N/A'}</span>;
    };

    chequeBounceChargeBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        const charge = parseFloat(rowData.detail?.amountPaying || rowData.detail?.chequeBounceAmt) || 0;
        return <span style={{ textAlign: 'right', display: 'block' }}>
            ₹{charge.toFixed(2)}
        </span>;
    };

    actionsBodyTemplate = (rowData) => {
        if (!rowData.isFirstRow) return '';
        return (
            <div className="action-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button
                
                    label='Print'
                    className="p-button-text"
                    tooltipOptions={{ position: 'top' }}
                    style={{ color: '#ffffff' , backgroundColor: '#076EFF',  }}
                    onClick={() => {
                        this.setState({
                            isEnableReceipt: true,
                            receiptData: rowData.transaction
                        });
                    }}
                />
            </div>
        );
    };

    render() {
        const { flattenedData, isLoading } = this.state;

        return (
            <div className="cheque-bounce-payments-table-container">
                {isLoading && <LoadingComponent />}

                {!isLoading && (
                    <div className="transactions-table-wrapper">
                        <div className="data-table-scroll-container" ref={this.dataScrollRef}>
                            <DataTable
                                value={flattenedData}
                                scrollable
                                scrollHeight="flex"
                                className="transactions-table"
                                showGridlines
                                emptyMessage="No records to display !!!"
                            >
                                <Column
                                    header="S.No"
                                    body={this.snoBodyTemplate}
                                    headerClassName="sno-header"
                                    bodyClassName="sno-cell"
                                    style={{ width: '70px', minWidth: '70px', textAlign: 'center' }}
                                />
                                <Column
                                    header="Receipt Number"
                                    body={this.chequeNumberBodyTemplate}
                                    headerClassName="cheque-number-header"
                                    bodyClassName="cheque-number-cell"
                                    style={{ width: '150px', minWidth: '150px' }}
                                />
                                <Column
                                    header="Receipt Date"
                                    body={this.chequeBounceBodyTemplate}
                                    headerClassName="cheque-bounce-date-header"
                                    bodyClassName="cheque-bounce-date-cell"
                                    style={{ width: '130px', minWidth: '130px' }}
                                />
                                <Column
                                    header="Destination Bank"
                                    body={this.feeAccountNameBodyTemplate}
                                    headerClassName="fee-account-header"
                                    bodyClassName="fee-account-cell"
                                    style={{ width: '180px', minWidth: '180px' }}
                                />
                                <Column
                                    header="Remarks"
                                    body={this.bounceRemarksBodyTemplate}
                                    headerClassName="bounce-remarks-header"
                                    bodyClassName="bounce-remarks-cell"
                                    style={{ width: '200px', minWidth: '200px' }}
                                />
                                <Column
                                    header="Cheque Bounce Charge"
                                    body={this.chequeBounceChargeBodyTemplate}
                                    headerClassName="cheque-bounce-charge-header"
                                    bodyClassName="cheque-bounce-charge-cell"
                                    style={{ width: '200px', minWidth: '200px', textAlign: 'right' }}
                                />
                                <Column
                                    header="Actions"
                                    body={this.actionsBodyTemplate}
                                    headerClassName="actions-header"
                                    bodyClassName="actions-cell"
                                    style={{ width: '120px', minWidth: '120px', textAlign: 'center' }}
                                />
                            </DataTable>
                        </div>
                    </div>
                )}

                {this.state.isEnableReceipt && (
                    <NewFeeReciept
                        receiptData={this.state?.receiptData}
                        hideFeeReciept={() => {
                            this.setState({
                                isEnableReceipt: false,
                                receiptData: null
                            });
                        }}
                    />
                )}
            </div>
        );
    }
}
